import React, {useState} from "react";
import { StyledCheckboxInput, StyledConnectFBBlock, StyledP } from "../setup.style";
import FBLoginButton from "./FBLoginButton";
import {ErrorContainer} from "../../style/global.style";

const ConnectFB = ({ setFBState, FBState, error }) => {

    return (
        <>
            <StyledConnectFBBlock>
                <StyledP>
                    Our advanced integration creates a special blend of high value audiences directly in
                    Facebook Ads for Remarketing and Lookalike purposes.
                </StyledP>

                <FBLoginButton setFBState={setFBState} FBState={FBState} />

                {FBState.connectionFailed ? (
                        <ErrorContainer> { error }</ErrorContainer>
                ) : null}
            </StyledConnectFBBlock>

            <StyledCheckboxInput>
                <input
                    required={!FBState.FBConnected}
                    type="checkbox"
                    name="noAudiences"
                    id="noAudiences"
                    checked={FBState.noAudiencesChecked}
                    onChange={() => {
                        setFBState({
                            ...FBState,
                            noAudiencesChecked: !FBState.noAudiencesChecked,
                            connectionFailed: false,
                        });
                    }}
                />
                <label htmlFor="noAudiences">I don’t want the advanced audiences integration</label>
            </StyledCheckboxInput>
        </>
    );
}

export default ConnectFB;
